import React from 'react';

import "../pages/paymentPage.css";
import stoxboxLogo from '../assets/images/stoxbox-logo.png';
import ratingsStar from '../assets/images/ratings-star.png';
import appDownloads from '../assets/images/app-downloads.png';
import paymentShield from '../assets/images/payment-shield.png';
import { Grid } from '@mui/material';
import { lightBlue } from '@mui/material/colors';


const Header = ({ title }) => {
    return (
        <div>
            <img src={stoxboxLogo} alt="Stoxbox Logo" width="200px" style={{ margin: '0 auto', display: 'block' }} />
            <h5 className="product-title-banner">{title}</h5>
            <div className="product-images">
                <div className="product-image-text-wrapper">
                    <div className="product-containers">
                        <div><img src={paymentShield} alt="Secure Payment" className='product-details-imgs' /></div>
                        <div>Secure Payment <br />
                            <span style={{color:"lightBlue"}}>By Paytm</span></div>
                    </div>
                </div>
                <div className="product-image-text-wrapper">
                    <div className="product-containers">
                        <div>
                            <img src={ratingsStar} alt="Secure Payment" className='product-details-imgs' />
                            </div>
                        <div>App Ratings 4.6 of 5<br />
                            <span style={{color:"lightBlue"}}>770 Reviews</span></div>
                    </div>
                </div>
                <div className="product-image-text-wrapper">
                    <div className="product-containers">
                        <div>
                            <img src={appDownloads} alt="Secure Payment" className='product-details-imgs' style={{width: 'auto'}}/>
                        </div>
                        <div>10K+ Downloads<br />
                        <span style={{color:"lightBlue"}}>On Google Play</span></div>
                    </div>
                </div>
            </div>
        </div>



    )
}

export default Header